const ImageHamburgerMenuOpen = ({ fillColor }) => {
	return (
		<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
			<desc>Three horizontal lines representing a hamburger menu</desc>
			<path d="M15 30H33V28H15V30ZM15 25H33V23H15V25ZM15 18V20H33V18H15Z" fill={fillColor} />
		</svg>
	);
};

export default ImageHamburgerMenuOpen;
